import React from 'react';
import '../../assets/css/sections/why.css';

const WHY = () => {
    return (
        <section className="why-section">
            <div className="container">
                <h2 className="section-title">Why E-AquaHealth?</h2>
                
                <div className="quote-container">
                    <blockquote className="featured-quote">
                        {/* "Revolutionizing aquaculture health management through 
                        innovative AI-powered solutions and real-time monitoring." */}
                        ‘‘A platform tailored for the modern fish farmers’’
                    </blockquote>
                </div>
                
                <p className="section-description">
                    {/* At E-AquaHealth, we understand the critical challenges facing modern 
                    aquaculture facilities. Our comprehensive platform combines cutting-edge 
                    AI technology with expert veterinary knowledge to provide real-time 
                    health monitoring, early disease detection, and data-driven insights 
                    that help optimize your aquaculture operations. */}

At E-AquaHealth, we understand the unique challenges of fish farming. That is why we’ve designed a platform that is more than just a service provider- it’s a partner in your success. Our advanced diagnostic tools, expert support network, and comprehensive educational resources are tailored to help you maintain healthy fish stock, optimize your operations, and achieve your farming goals. Whether you’re an experienced farmer or just starting out, E-AquaHealth is here to provide the solutions and support you need to thrive.
                </p>
            </div>
        </section>
    );
};

export default WHY;